export default __webpack_public_path__ + "499cf87049864c1b2ca46a00be4bf2aa.jpg";